// Shared Framer Motion variants for consistent, premium feel
export const fadeUp = {
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.9, ease: [0.16, 1, 0.3, 1] },
};

export const fadeIn = {
  initial: { opacity: 0 },
  whileInView: { opacity: 1 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 1.2, ease: [0.16, 1, 0.3, 1] },
};

export const imageReveal = {
  initial: { scale: 1.06, opacity: 0 },
  whileInView: { scale: 1, opacity: 1 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 1.4, ease: [0.16, 1, 0.3, 1] },
};

export const stagger = (delay = 0.08) => ({
  initial: {},
  whileInView: {
    transition: { staggerChildren: delay, delayChildren: 0.1 },
  },
  viewport: { once: true, margin: "-80px" },
});
